import React from "react";
import JsBarcode from "jsbarcode";

import { Alert, Box } from "@mui/material";

export default function Barcode({ ean13, ...props }) {
  const [error, setError] = React.useState();
  const svgRef = React.useRef();

  React.useEffect(() => {
    setError(null);

    try {
      JsBarcode(svgRef.current, ean13, {
        format: "EAN13",
        lineColor: "currentColor",
        background: "transparent",
      });
    } catch (err) {
      setError(err);
    }
  }, [ean13]);

  return (
    <Box {...props}>
      {error && <Alert severity="error">{error.toString()}</Alert>}

      <Box
        component="svg"
        sx={{
          display: error ? "none" : "initial",
          maxWidth: "100%",
          height: "auto",
        }}
        ref={svgRef}
      />
    </Box>
  );
}
